import { ContentBlockViewComponent, ContentModule } from '@tytapp/content';
import { LiveScheduleBlock } from './live-schedule-block';
import { Component, Input } from '@angular/core';
import { LiveUiModule } from '../live-ui.module';

@Component({
    selector: 'tyt-live-schedule-block',
    standalone: true,
    imports: [ ContentModule, LiveUiModule ],
    template: `
        <tyt-content-card title="Live Schedule" [icon]="{ type: 'material', text: 'podcasts' }">
            <div class="actions">
                <a mat-button url="/live/schedule">
                    <mat-icon>open_in_browser</mat-icon>
                    Full Schedule
                </a>
            </div>
            <tyt-todays-live-schedule
                [numberOfDays]="block?.numberOfDays || 2"
                [maximumEvents]="block?.maximumEvents || 8"
                />
        </tyt-content-card>
    `,
    styles: [`
        // TODO
    `]
})
export class ViewComponent extends ContentBlockViewComponent<LiveScheduleBlock> {
    @Input() block: LiveScheduleBlock;

    onBlockChanged(): void {
    }
}
